export default (url, protocolHeaderArr) => {
    let prefix = protocolHeaderArr[0];
    protocolHeaderArr.map((protocolHeader) => {
        if (url.substring(0, protocolHeader.length) === protocolHeader) {
            prefix = '';
        }
    })
    return prefix + url
}